<template>
  <span>
    <i :class="[icon, color]" class="font-size-24 align-middle " v-b-tooltip.hover :title="text"></i>
    <span v-if="showText" class="mr-1 ml-1">{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: ["acceptance", "showText"],
  computed: {
    icon() {
      if (this.acceptance == "UNWORKED") {
        return "iconoir-shield";
      } else if (this.acceptance == "APPLYING") {
        return "iconoir-shield-check";
      } else if (this.acceptance == "NOT_APPLYING") {
        return "iconoir-shield-xmark";
      } else if (this.acceptance == "REJECTED") {
        return "iconoir-shield-minus";
      } else if (this.acceptance == "PERIODIC_APPROVAL") {
        return "iconoir-shield-search";
      }

      return "iconoir-shield-check";
    },
    color() {
      if (this.acceptance == "UNWORKED") {
        return "text-muted";
      } else if (this.acceptance == "APPLYING") {
        return "text-success";
      } else if (this.acceptance == "NOT_APPLYING") {
        return "text-danger";
      } else if (this.acceptance == "REJECTED") {
        return "text-muted";
      } else if (this.acceptance == "PERIODIC_APPROVAL") {
        return "text-warning";
      }

      return "text-muted";
    },
    text() {
      if (this.acceptance == "UNWORKED") {
        return this.$t("policy.acceptance.unworked");
      } else if (this.acceptance == "APPLYING") {
        return this.$t("policy.acceptance.applying");
      } else if (this.acceptance == "NOT_APPLYING") {
        return this.$t("policy.acceptance.not-applying");
      } else if (this.acceptance == "REJECTED") {
        return this.$t("policy.acceptance.rejected");
      } else if (this.acceptance == "PERIODIC_APPROVAL") {
        return this.$t("policy.acceptance.periodic-approval");
      }

      return this.$t("policy.acceptance.unworked");
    },
  },
};
</script>

<style scoped></style>
